package uz.ferro.erp.error

class HttpException(
    val code: Int,
    val errorResponse: String
) : RuntimeException("Response error")